<a mat-list-item (click)="toggle()" style="width: fit-content;">
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
            class="submenu">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
                <mat-icon>table_chart</mat-icon>
                <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>

    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

            <!-- ENTIDADE SOCIAL -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().ENTIDADE_SOCIAL)" icone="home_work" titulo="Entidade Social" rota="entidadesocial" toolTip="Entidade Social"></sub-menu>
            </div>

            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().MATRICULA_SECRETARIA)" icone="school" titulo="Matrícula Secretaria" rota="matriculasecretaria" toolTip="Matrícula Secretaria"></sub-menu>
            </div>

            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().ESCOLA)" icone="school" titulo="Escola" rota="escola" toolTip="Escola"></sub-menu>
            </div>

            <!-- FERIADO-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().FERIADO)" icone="event" titulo="Feriado" rota="feriado" toolTip="Feriado"></sub-menu>
            </div>

        </div>
    </mat-nav-list>
